module.exports = __webpack_public_path__ + "static/media/Coursera_logo.6cc6479f.png";